<template>
  <a :href="finalIosStoreLink" :style="'height: '+(small ? '26px' : '50px')" target="_blank">
    <img
      style="height: 100%;"
      src="@/assets/appleStore.svg"
      :alt="$t('alts.appStore')"
    />
  </a>
</template>

<script>
import { IOS_STORE_STORY_CITY_URL } from "@/const";
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    linkOverride: {
      type: String,
      default: null,
    }
  },
  computed: {
    finalIosStoreLink() {
      if (this.$route.query.ios_link) {
        return this.$route.query.ios_link;
      }
      
      if (this.linkOverride) {
        return this.linkOverride;
      }
      
      return IOS_STORE_STORY_CITY_URL;
    },
  },
};
</script>
